// 因后端有时不会对设备进行异常判断
// 故该模块基于对后端返回的数据判断各种设备的异常

/**
 * 该函数最后会将所有的传感器异常情况 添加到传感器对象中的ex属性中
 * @param {Array} sensorList 传感器数组
 */
export const sensorEx = function (sensorList = []) {
  return sensorList.map(sensor => {
    // 用于存储异常
    const ex = []
    // 状态 离线和停用均判断为连接异常
    if (sensor.deviceStatus !== 1) {
      ex.push($t('public.ex_conn'))
    }
    sensor.deviceCatalog = String(sensor.deviceCatalog)
    if (typeof sensor.probeValue === 'string') sensor.probeValue = JSON.parse(sensor.probeValue)
    // 存在温度值
    if (sensor.probeValue && sensor.probeValue.temp) {
      const tempVal = sensor.probeValue.temp.val
      // 找到温度区间值才去判断异常
      if (sensor.minTemp !== undefined && sensor.maxTemp !== undefined) {
        if (tempVal < sensor.minTemp || tempVal > sensor.maxTemp) ex.push($t('public.ex_temp'))
      }
    }

    // 存在湿度值
    if (sensor.probeValue && sensor.probeValue.hum) {
      const humVal = sensor.probeValue.hum.val
      // 找到湿度区间值才去判断异常
      if (sensor.minHum !== undefined && sensor.maxHum !== undefined) {
        if (humVal < sensor.minHum || humVal > sensor.maxHum) ex.push($t('public.ex_hum'))
      }
    }

    if (sensor.isNoData === 1) {
      ex.push($t('public.ex_data'))
    }

    // 监测点到本身对象上
    sensor.ex = ex
    if (ex.length) {
      sensor.abnormal = 1
    } else {
      sensor.abnormal = 0
    }
    return sensor
  })
}

// 网关异常判断 同传感器
export const gatewayEx = function (gatewayList = []) {
  return gatewayList.map(gateway => {
    const ex = []
    if (gateway.status !== 1) {
      ex.push($t('public.ex_conn'))
    }
    gateway.ex = ex
    if (ex.length) {
      gateway.abnormal = 1
    } else {
      gateway.abnormal = 0
    }
    return gateway
  })
}

// 显示屏异常判断
export const displayEx = function (displayList = []) {
  return displayList.map(display => {
    const ex = []
    if (display.status !== 1) {
      ex.push($t('public.ex_conn'))
    }
    display.ex = ex
    if (ex.length) {
      display.abnormal = 1
    } else {
      display.abnormal = 0
    }
    return display
  })
}

// 中继异常判断
export const relayEx = function (relayList = []) {
  return relayList.map(relay => {
    const ex = []
    if (relay.status !== 1) {
      ex.push($t('public.ex_conn'))
    }
    relay.ex = ex
    if (ex.length) {
      relay.abnormal = 1
    } else {
      relay.abnormal = 0
    }
    return relay
  })
}
